import { render, staticRenderFns } from "./SearchNavItemCompany.vue?vue&type=template&id=629fb6a0&scoped=true&"
import script from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemCompany.vue?vue&type=style&index=0&id=629fb6a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629fb6a0",
  null
  
)

export default component.exports